import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getBalances && _ctx.getBalances(...args)))
    }, "Get Balances"),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokens, (token) => {
      return (_openBlock(), _createElementBlock("div", {
        key: token.address
      }, [
        (_ctx.vks[token.symbol])
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("span", null, _toDisplayString(token.symbol), 1),
              _hoisted_2,
              _createElementVNode("span", null, _toDisplayString(_ctx.coinConvert(_ctx.balances[token.symbol],token.decimals,'human')), 1)
            ]))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: ($event: any) => (_ctx.createViewingKey(token))
            }, "Get Viewing Key for " + _toDisplayString(token.symbol), 9, _hoisted_3))
      ]))
    }), 128))
  ]))
}